import { useContext, createContext } from 'react';

import contextProviderFactory from './contextProviderFactory';
import { initRootState, rootReducer } from './reducer';

export const RootContext = createContext(initRootState);
export const useRootContext = () => useContext(RootContext);

const RawRootProvider = contextProviderFactory(RootContext);

export const RootProvider = ({ children }) => (
  <RawRootProvider initialState={initRootState} reducer={rootReducer}>
    {children}
  </RawRootProvider>
);
